
<template>
    <vue-draggable-resizable v-bind:class="{ procesado: dataFirma.procesado }" class="dragndrop" v-if="width && height" :w="width" :h="height" :x="x" :y="y" :id="id" @dragging="onDrag" @resizing="onResize" :parent="true"  :draggable="canDrag" :resizable="canResize" :lock-aspect-ratio="true" :minHeight="30" :maxHeight="75" :minWidth="150" :maxWidth="250" style="z-index: 1;">
        <div class="draggable-content mx-auto" :style="{borderColor:colorProp}" style="height: 100%; width: 100%; color: black; background-color: transparent; border: dashed 3px;">
          <div v-if="canDrag">
            {{labelProp}}
              <b-button  :id=" 'del-'+id " v-b-tooltip.bottom="'Eliminar'" @click="seguroEliminarControl()" class="w-full vs-con-loading__container p-0" variant="flat-secondary"><feather-icon icon="XIcon" svgClasses="" /></b-button>
          </div>
          <div style="height: 100%; width: 100%;" class="text-center" :class="{'mt-2': !canDrag}">
              <p :style="estilo" v-if="firmante"><b>{{ firmante.nombres }}</b></p>
              <p :style="estilo" v-else><b>Nombre de Firmante...</b></p>
          </div>
        </div>
    </vue-draggable-resizable>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/src/components/vue-draggable-resizable.css';
  export default{
    name: 'dragndropSignerName',
    data () {
        return {
          width: 0,
          height: 0,
          x: 0,
          y: 0,
        }
    },
    created () {
      this.x = this.xProp
      this.y = this.yProp
      this.width = this.widthProp
      this.height = this.heightProp
    },
    props:{
      id: String,
      keyProp: String,
      xProp: Number,
      yProp: Number,
      colorProp: String,
      labelProp: String,
      tipoFirma: String,
      widthProp: Number,
      heightProp: Number,
      // file: Object,
      dataFirma:Object,
      firmante: Object,
      firmanteActivo: {
      type: Object,
      default: null
      },
      padre: Object,
      page: Number,
      controlProp: Number,
      canDrag: {
      type: Boolean,
      default: true,
      },
      canResize: {
      type: Boolean,
      default: false
      },
      firmar: { type: Function },
    },
    mounted(){

    },
    methods: {
      onResize: function (x, y, width, height) {
        this.padre.cambiosCurrentFile = true
        this.x = x
        this.y = y
        try{
          if(width > 50 && width < 250){
            this.width = width
          }
          if(height > 50 && height < 250){
            this.height = height
          }
        }catch{}
      },
      onDrag: function (x, y) {
          this.padre.cambiosCurrentFile = true
          this.x = x
          this.y = y
      },
      del(){
      },
      getPosition: function(){
        var response = {id: this.id, control:this.controlProp, key: this.keyProp, x_pos: this.x, y_pos: this.y, width:this.width, height: this.height, firmante: this.firmante, page: this.page, tramite_control: this.dataFirma.tramite_control}
        return response
      },
      probar(){
        this.openLoadingContained()
        this.firmar(this.dataFirma)
        this.closeLoadingContained()
      },

      openLoadingContained(){
        this.$vs.loading({
          background: "primary",
          color: "#fff",
          container: "#btn-"+this.id,
          scale: 0.45,
          type: "sound"
        })
        setTimeout( ()=> {
        this.$vs.loading.close("#btn-"+this.id+ "> .con-vs-loading")
          }, 3000);
      },

      closeLoadingContained(){
          this.$vs.loading.close("#btn-"+ this.id + ">.con-vs-loading")
          this.bloqueo_boton=false
      },

      openConfirm( ){
          var pregunta = '¿Está seguro que desea firmar digitaelectrónicamentelmente?'
          var titulo = 'Firma digital'
          if (this.tipoFirma == "E"){
            pregunta = '¿Está seguro que desea firmar electrónicamente?'
            titulo = 'Firma Electrónica'
          }
          this.$swal({
            title: titulo,
            text: pregunta,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d9534f',
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
          }).then(result => {
            if (result.value) {
              this.probar()
            }
          })
      },

      seguroEliminarControl(){
        this.padre.seguroEliminarControl(this)
      },

      eliminarControl(id){
        this.padre.cambiosCurrentFile = true
        for(var i=0; i<this.padre.controles.length; i++){
          if(String(this.padre.controles[i].id) == id){
            // console.log('controles')
            // console.log(this.padre.controles[i].id, id)
            this.padre.controles.splice(i, 1);
          }
        }
        for(var i=0; i<this.padre.controlesNuevos.length; i++){
          if(String(this.padre.controlesNuevos[i].id) == id){
            // console.log(this.padre.controlesNuevos[i].id, id)
            this.padre.controlesNuevos.splice(i, 1);
          }
        }
        if(id.split('_')[0]=='con'){
          this.padre.controlesEliminados.push(id)
        }
        // console.log(this.padre.controles)
      },
    },
    components: {
      'vue-draggable-resizable':VueDraggableResizable
    },
      computed:{
        informacion: function(){
            var info ={};
            var tipo =""
            if (this.tipoFirma== "E"){
                tipo = "electrónicamente"
            }else{
                tipo = "electrónicamente"
            }
            info.mensaje="Firmado "+ tipo;
            info.firmante=this.firmante.nombres;
            info.fecha_procesado= this.dataFirma.fecha_procesado;
            return info;
        },

        estilo: function(){
            if(document.body.clientWidth > 900){
              return "font-size:" +12+"px";
            }else{
              return "font-size:" +8+"px";
            }
        }


    },


  }
</script>
<style>
.dragndrop{
  border-style: none;
}

.procesado .draggable-content{
  border-style: dashed 1px !important;
}

.draggable-content.mx-auto .con-vs-tooltip {
  width: 20px;
  height: 20px;
  float: right;
}


.draggable-content.mx-auto .con-vs-tooltip .vs-component.vs-button.w-full.vs-con-loading__container.vs-button-primary.vs-button-flat.includeIcon.includeIconOnly{
  padding: 2px;
  height: 20px !important;
}



.draggable.resizable.vdr{
   border: none;
   background-color: transparent;
}

.draggable.resizable.vdr{
  max-width: 250px;
  min-width: 50px;
  max-height: 250px;
  min-height: 50px;
}

</style>


